import React from 'react';

const CheckoutFailure = () => {
  return (
    <div>
      <div>Failure!</div>
    </div>
  );
};

export default CheckoutFailure;
